import { IonApp, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonContent, IonGrid, IonHeader, IonicModule, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonItem, IonLabel, IonRow, IonTab, IonTabBar, IonTabButton, IonTabs, IonTitle, IonToolbar } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { PageRoutingModule } from './page-routing.module';

import { TabsPage } from './tabs-page/tabs.page';
import { ChecklistComponent } from './checklist/checklist.component';
import { OrganisationComponent } from './organisation/organisation.component';
import { AddressComponent } from './address/address.component';
import { PartiesComponent } from './parties/parties.component';
import { RiskComponent } from './risk/risk.component';
import { DeclarationComponent } from './declaration/declaration.component';
import { FaqComponent } from './faq/faq.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Drivers } from '@ionic/storage'; //Ionic storage drivers, we are going to use local storage
import { IonicStorageModule } from '@ionic/storage-angular'; // Ionic's angular storage module

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    PageRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    IonicStorageModule.forRoot({name: '__afldb', driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage]}), //Import Ionic storage for root
  ],
  declarations: [
    TabsPage,
    ChecklistComponent,
    OrganisationComponent,
    AddressComponent,
    PartiesComponent,
    RiskComponent,
    DeclarationComponent,
    FaqComponent,
  ]
})
export class PageModule {}
